import "./tabsHomePage.css"
import React, { useState, useEffect, useContext } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { TabContext, TabList } from '@mui/lab'
import { Tab, Grid, useMediaQuery, Chip, Avatar, Menu, MenuItem, Paper, IconButton, ListItem, ListItemButton, ListItemText, Tooltip, } from '@mui/material'
import ScrollToTop from "react-scroll-to-top"
import { useTranslation } from "react-i18next"
import CloseIcon from '@mui/icons-material/Close'
import GenericEntity from '../../pages/genericEntity'
import ExtensionFormDemo from '../../pages/extensionFormDemo'
import { M_Button, NavigateContext, LoadingContext, } from "src/M_Components"
import { SettingsPage } from "../settings/SettingsPage"
import M_LateralMenu from "src/M_Components/M_LateralMenu/M_LateralMenu"
import { menuObject } from "./menuObject"
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import UserMobileSettings from "../utils/userMobileSettings"
import { useGenericEntityMenu } from '../genericEntity/hooks/useGenericEntityMenu'
import { ArrowRight, Logout, Settings } from "@mui/icons-material"
// import { useGenericEntityMenu } from '../genericEntity/hooks/useGenericEntityMenu'

export default function TabsHomePage({ roles }) {

    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const ctx = useContext(LoadingContext)
    const matches = useMediaQuery('(max-width: 750px)')
    const tempMenu = (menuObject)

    //UserAccount Menu
    const [accountName, setAccountName] = useState("")
    const [accountCompany, setAccountCompany] = useState("")
    const [showMenu, setShowMenu] = useState(false)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

    // ✨ ENTIDADES DINÂMICAS DO BACKEND
    const { entities: geEntities, loading: geLoading, refreshMenu: refreshGEMenu } = useGenericEntityMenu()

    const menuRoles = (data) => {
        const tempMenus = data
        const tempRoles = roles.filter(obj => obj.includes('List')).map(obj => obj.replace('List', '').toUpperCase())
        
        const tempMenuArray = []
        tempMenus?.forEach(obj => {
            //  EXTENSION DEMO
            if (obj.tableName === 'EXTENSION_DEMO') {
                tempMenuArray.push(obj)
                return;
            }
            // ⚠️ TRATAMENTO ESPECIAL PARA GENERIC ENTITY
            if (obj.tableName === 'GENERICENTITY') {
                // Verificar se tem permissão Admin ou User
                const hasAdminPermission = roles.some(role => 
                    role.toLowerCase().includes('genericentity') && role.toLowerCase().includes('admin') && role.toLowerCase().includes('list')
                )
                const hasUserPermission = roles.some(role => 
                    role.toLowerCase().includes('genericentity') && role.toLowerCase().includes('user') && role.toLowerCase().includes('list')
                )
                
                // Se não tiver nenhuma permissão, não mostrar menu
                if (!hasAdminPermission && !hasUserPermission) {
                    return;
                }
                
                const baseSubMenus = []
                
                // Admin Config só aparece para Admin
                if (hasAdminPermission) {
                    baseSubMenus.push({
                        subMenuLabel: "AdminConfig",
                        subMenuDisplay: t("Configuration") || "Configuration",
                        tableName: "GENERICENTITY_ADMIN",
                        subMenuUrl: "genericentity/admin",
                        subSubMenus: []
                    })
                }
                
                // Adicionar entidades se houver (após carregamento)
                if (!geLoading && geEntities.length > 0) {
                    baseSubMenus.push(...geEntities.map(entity => ({
                        ...entity,
                        // Usar tradução do i18n se disponível
                        subMenuDisplay: entity._captions?.[i18n.language] || entity.subMenuDisplay
                    })))
                }
                
                // Só adicionar ao menu se houver itens para mostrar
                if (baseSubMenus.length > 0) {
                    obj.subMenus = baseSubMenus
                    tempMenuArray.push(obj)
                }
                return; // Sair cedo para evitar processamento adicional
            }
            
            if (obj?.subMenus && obj?.subMenus?.length > 0) {
                const tempSubMenus = obj?.subMenus?.filter(resObj => {
                    if (resObj.tableName) {
                        if (tempRoles.includes(resObj.tableName.toUpperCase())) {
                            return resObj
                        }
                    } else {
                        if (resObj.subsubMenus.length > 0) {
                            // console.log('SubSubMenus')
                        }
                    }
                })
                if (tempSubMenus.length > 0) {
                    obj.subMenus = tempSubMenus
                    tempMenuArray.push(obj)
                }
            } else {
                if (tempRoles.includes(obj.tableName.toUpperCase())) {
                    tempMenuArray.push(obj)
                }
            }
        })
        return tempMenuArray
    }

    //lateralMenu
    const [menus, setMenus] = useState(menuRoles(tempMenu))

    // Recalcular menus quando entidades do GE carregarem ou idioma mudar
    useEffect(() => {
        setMenus(menuRoles(tempMenu))
    }, [i18n.language, geEntities, geLoading])

    const handleLogout = () => {
        // console.log('teste handle logout')
        setShowMenu(false)
        localStorage.clear()
        sessionStorage.clear()
        navigate(`/login`)
    }

    //tabs
    const [selectedTab, setSelectedTab] = useState('menu')
    const [tabs, setTabs] = useState([])
    const [tabIndex, setTabIndex] = useState(1)
    const [showButtons, setButtons] = useState(true)
    const [isFirstTime, setIsFirstTime] = useState(true)

    //menu favorites
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    //MainMenusStates
    const [btnState1, setBtnState1] = useState(false)
    const [btnState2, setBtnState2] = useState(false)
    const [btnState3, setBtnState3] = useState(false)



    // eslint-disable-next-line
    useEffect(() => {
        const name = localStorage.getItem(`accountName`)
        const company = localStorage.getItem(`accountCompany`)
        if (name !== null && company !== null) {
            setAccountName(name)
            setAccountCompany(company)
        }
    })

    useEffect(() => {
        const tbs = sessionStorage.getItem('tabs')
        const sltbs = sessionStorage.getItem('selectedTab')
        const swbts = sessionStorage.getItem('showButtons')
        const tabIndx = sessionStorage.getItem('tabIndex')

        if (tbs !== null && sltbs !== null && swbts !== null) {
            setTabs(JSON.parse(tbs))
            setSelectedTab(JSON.parse(sltbs))
            setButtons(JSON.parse(swbts))
            setTabIndex(JSON.parse(tabIndx))
        }
    }, [])

    useEffect(() => {
        if (isFirstTime === true) {
            setTimeout(() => {
                setSelectedTab("menu")
                setShowMenu(true)
                navigate(`/home`)
                setButtons(true)
                setIsFirstTime(false)
            }, 50)
        } else {
            sessionStorage.setItem('tabs', JSON.stringify(tabs))
            sessionStorage.setItem('selectedTab', JSON.stringify(selectedTab))
            sessionStorage.setItem('showButtons', JSON.stringify(showButtons))
            sessionStorage.setItem('tabIndex', tabIndex)
        }
    }, [tabs, selectedTab, showButtons, tabIndex, isFirstTime, navigate])

    const handleChange = (event, newValue) => {
        //* was event.target.role
        if (event.target.type) {
            setSelectedTab(newValue)
            sessionStorage.setItem('selectedTab', JSON.stringify(newValue))
            return
        }
    }

    async function versionControl() {
        const newVersion = await fetch('/version.txt')
        const oldVersion = localStorage.getItem('version')
        const versionText = await newVersion.text()

        if (versionText != oldVersion) {
            window.location.reload(true)
            localStorage.setItem('version', versionText)
        }
    }

    const goToPage = (url, passLabel) => {
        versionControl()
        const label = passLabel ? passLabel : url.slice(url.search('/') + 1)
        navigate(`${url}`)
        setButtons(false)

        const newTab = {
            value: `${tabIndex}`,
            label: label,
            tabUrl: `${url}`
        }
        setTabs([...tabs, newTab])
        setSelectedTab(`${tabIndex}`)
        sessionStorage.setItem('selectedTab', JSON.stringify(`${tabIndex}`))
        setTabIndex(tabIndex + 1)
        ctx.toastMessages('success', '', t("MessageTabCreated"))
    }

    const handleTabClose = (value) => {
        sessionStorage.removeItem('lines')
        sessionStorage.removeItem('context')
        sessionStorage.removeItem('contextLine')
        const tabKeys = JSON.parse(sessionStorage.getItem(`tab"${value}"`))
        if (JSON.parse(sessionStorage.getItem(`tab"${value}.1"`))) {
            const tempParentTable = JSON.parse(sessionStorage.getItem(`tab"${value}.1"`))
            if (tempParentTable) {
                tempParentTable.forEach(elem => {
                    sessionStorage.removeItem(`"${value}.1"${elem}`)
                    sessionStorage.removeItem(`tab"${value}.1"`)
                })
            }
            if (JSON.parse(sessionStorage.getItem(`tab"${value}.2"`))) {
                const tempParentTable = JSON.parse(sessionStorage.getItem(`tab"${value}.2"`))
                if (tempParentTable) {
                    tempParentTable.forEach(elem => {
                        sessionStorage.removeItem(`"${value}.2"${elem}`)
                        sessionStorage.removeItem(`tab"${value}.2"`)
                    })
                }
            }
        }

        if (tabKeys) {
            tabKeys.forEach(elem => {
                sessionStorage.removeItem(`"${value}"${elem}`)
                sessionStorage.removeItem(`tab"${value}"`)
            })
        }

        const tabArr = tabs.filter(t => t.value !== value)
        if (tabArr.length === 0) {
            setTabs([])
            menusRoute()
            setSelectedTab('menu')
        } else {
            if (selectedTab === value) {
                setSelectedTab('menu')
                menusRoute()
            }
            setTabs(tabArr)
        }
        ctx.toastMessages('success', '', t("MessageTabClosed"))
    }

    const menusRoute = () => {

        setSelectedTab("menu")
        setShowMenu(true)
        navigate(`/home`)
        setButtons(true)
    }

    const tabsRoutes = (url, event) => {
        //* was event.target.role
        if (event.target.type) {
            navigate(`/home/${url}`)
            setButtons(false)
            setShowMenu(false)
        }
    }

    const handleChangeLng = (lng) => {
        i18n.changeLanguage(lng)
        localStorage.setItem("lng", lng)
    }

    const handleSettings = () => {
        // console.log('teste settings')
        setShowMenu(false)
        setMobileMoreAnchorEl(null)
        goToPage('settings', 'Settings')
    }

    const lastMenus = [
        {
            menuLabel: "SettingsSpan",
            onClick: handleSettings,
            menuIcon: <Settings style={{ color: "var(--color-grey-dark)" }} />
        },
        {
            menuLabel: "LogoutSpan",
            onClick: handleLogout,
            menuIcon: <Logout style={{ color: "var(--color-grey-dark)" }} />
        }
    ]

    return (
        <NavigateContext.Provider value={{
            newTab: goToPage,
            closeTab: handleTabClose,
        }}>
            <Grid container className='divTabs'>
                <Grid item xs={12} sm={12} md={12} lg={1.5} >
                    <div className="buttonsDiv">
                        <M_Button
                            none
                            width={'0px'}
                            tooltip={'Home'}
                            icon={<img style={{ width: '190px' }} src="/images/Webtrans.png" alt="home" />}
                            onClick={menusRoute}
                        />
                    </div>
                </Grid>
                <Grid item xs={2.5} sm={2} md={2} lg={.5}>
                    <div className="divFavoritesAndAccount">
                        <M_Button
                            none
                            hoverEffect
                            tooltip={'Menu'}
                            icon={open ? <i className="buttonFavorites pi pi-list"></i> : <i className="buttonFavorites pi pi-bars"></i>}
                            onClick={() => { setShowMenu(!showMenu) }}
                        />
                    </div>
                </Grid>
                <Grid item xs={6.5} sm={7} md={7} lg={9}>
                    <TabContext value={selectedTab}>
                        <TabList
                            scrollButtons={true}
                            allowScrollButtonsMobile
                            TabIndicatorProps={{ style: { display: "none", } }}
                            className="tabList"
                            onChange={handleChange}
                            aria-label="Dynamic Tabs"
                            variant="scrollable"
                        >
                            <Tab value="menu" disableRipple={true} className="selectedTabDefault" />
                            {tabs.map((tab, index) => (
                                <Tab
                                    onClick={(event) => {
                                        tabsRoutes(tab.tabUrl, event)
                                    }}
                                    onMouseDown={(event) => {
                                        if (event.button === 1) {
                                            document.body.onmousedown = e => { if (e.button === 1) return false; }
                                            handleTabClose(tab.value)
                                        }
                                    }}
                                    disableRipple={true}
                                    key={index}
                                    label={tab.label}
                                    value={tab.value}
                                    icon={
                                        <M_Button
                                            none
                                            icon={<CloseIcon fontSize='5px' />}
                                            onClick={() => handleTabClose(tab.value)}
                                        />
                                    }
                                    iconPosition="end"
                                />
                            ))}
                        </TabList>
                    </TabContext>
                </Grid>
                <Grid item xs={3} sm={3} md={3} lg={1}>
                    <div className="divAccount" style={{ cursor: 'pointer' }} onClick={(event) => { setMobileMoreAnchorEl(event.currentTarget) }}>
                        <Chip
                            style={{ backgroundColor: 'transparent', borderRadius: '10px', color: 'var(--color-white)' }}
                            avatar={
                                <Avatar style={{ fontWeight: 'bold', color: 'var(--color-grey-dark)', backgroundColor: 'var(--color-grey-light)' }} >
                                    {`${accountName.charAt(0)}`}
                                </Avatar>
                            }
                            label={`${accountCompany}`}
                        />
                    </div>
                    <Menu anchorEl={mobileMoreAnchorEl} open={isMobileMenuOpen} onClose={() => setMobileMoreAnchorEl(null)}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <div style={{ margin: "5px", backgroundColor: 'white', width: '220px', height: "220px", }}>
                            {lastMenus.map((menu, key) => (
                                <ListItem component="div" disablePadding key={key}
                                    sx={{ "& .MuiListItemButton-root:hover ": { backgroundColor: 'transparent' } }}
                                >
                                    <ListItemButton 
                                        sx={{ height: 40, cursor: 'cursor', maxWidth: '220px' }} 
                                        disableRipple 
                                        onClick={() => `${menu?.onClick()}`}
                                        disabled={menu?.menuLabel === "SettingsSpan"}
                                    >
                                        <ListItemText primary={`${t(menu?.menuLabel)}`} primaryTypographyProps={{ color: "var(--color-grey-dark)", fontWeight: "bold" }} />
                                    </ListItemButton>
                                    <Tooltip title={`${t(menu?.menuLabel)}`} placement="right">
                                        <IconButton size="large" disableRipple={true} onClick={() => `${menu?.onClick()}`}
                                            disabled={menu?.menuLabel === "SettingsSpan"}
                                            sx={{
                                                "& svg": {
                                                    color: "rgba(255,255,255,0.8)",
                                                    transition: "0.2s",
                                                    transform: "translateX(0) rotate(0)",
                                                },
                                                "&:hover, &:focus": {
                                                    bgcolor: "unset",
                                                    "& svg:first-of-type": { transform: "translateX(-4px) rotate(-20deg)" },
                                                    "& svg:last-of-type": { right: 0, opacity: 1 }
                                                },
                                                "&::after": {
                                                    content: '""',
                                                    position: "absolute",
                                                    height: "80%",
                                                    display: "block",
                                                    left: 0,
                                                    width: "1px",
                                                    bgcolor: "divider",
                                                },
                                            }}
                                        >
                                            {menu?.menuIcon}
                                            <ArrowRight
                                                style={{ color: "var(--color-grey-dark)" }}
                                                sx={{ position: "absolute", right: 4, opacity: 0 }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </ListItem>
                            ))}
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginTop: '5px', marginBottom: '5px' }}>
                                <Tooltip title={"EN"} placement="top">
                                    <img style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("en")} src='/icons/flagIcons/EN.png' alt="EN" width="40px" />
                                </Tooltip>
                                <Tooltip title={"ES"} placement="top">
                                    <img style={{ cursor: 'pointer' }} onClick={() => handleChangeLng("es")} src='/icons/flagIcons/ES.png' alt="ES" width="40px" />
                                </Tooltip>
                                <Tooltip title={"PT"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("pt")} src='/icons/flagIcons/PT.png' alt="PT" width="40px" />
                                </Tooltip>
                                <Tooltip title={"FR"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("fr")} src='/icons/flagIcons/FR.png' alt="FR" width="40px" />
                                </Tooltip>
                                <Tooltip title={"IT"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("it")} src='/icons/flagIcons/IT.png' alt="IT" width="40px" />
                                </Tooltip>
                                <Tooltip title={"DE"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("de")} src='/icons/flagIcons/DE.png' alt="DE" width="40px" />
                                </Tooltip>
                                <Tooltip title={"JP"} placement="top">
                                    <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("jp")} src='/icons/flagIcons/JP.png' alt="JP" width="40px" />
                                </Tooltip>
                            </div>
                            <div style={{ height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderTop: '1px solid var(--color-grey)', fontWeight: 'bold', color: 'var(--color-grey-dark)' }} >
                                <span style={{ width: '215px', textAlign: 'center' }}> {accountName} | {accountCompany} </span>
                            </div>
                        </div>
                    </Menu>
                </Grid>
                <M_LateralMenu
                    handleChangeLng={handleChangeLng}
                    handleLogout={handleLogout}
                    handleSettings={handleSettings}
                    showMenu={showMenu}
                    setShowMenu={setShowMenu}
                    menus={menus}
                    setMenus={setMenus}
                    bodyPage={
                        showButtons && <>
                            {matches ?
                                <div
                                    className="webtransCenter"
                                    style={{ width: '100vw', }}
                                >
                                    <img
                                        style={{ maxHeight: '300px' }}
                                        src="/images/WebtransLogo.png"
                                        alt="WEBTRANS LOGO"
                                    />
                                </div>
                                :
                                <div
                                    className='PSLLayout'
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        opacity: 0.5,
                                        width: '100vw',
                                    }} >
                                    <div className="e4414_14511">
                                        <div className="e4414_14506"></div>
                                        <div className="e4414_14507"></div>
                                        <div className="e4414_14508"></div>
                                        <div className="e4414_14509"></div>
                                        <div className="e4414_14510"></div>
                                    </div>
                                </div>
                            }
                        </>

                    }
                />
            </Grid>
            <div className='baseLine'>
                <ScrollToTop
                    smooth
                    component={<ArrowUpwardIcon fontSize="large" style={{ color: 'var(--color-white)' }} />}
                    style={{
                        backgroundColor: `${ctx.primaryColor ? ctx.primaryColor : "var(--color-black)"}`,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '45px',
                        height: '45px'
                    }} />
                <Routes>
                    <Route path='/settings' element={<SettingsPage />} />
                    <Route path='/extension-demo' element={<ExtensionFormDemo />} />
                    <Route path='/genericentity/*' element={
                        <GenericEntity 
                            showButtons={showButtons}
                            onCreateTab={goToPage}
                            roles={roles}
                            handleTabClose={handleTabClose}
                            toastMessages={ctx.toastMessages}
                        />
                    } />
                </Routes>
            </div>
        </NavigateContext.Provider >
    )
}